import React, {useState} from 'react'
import gql from 'graphql-tag'
import {notification} from 'antd'
import {useQuery, useMutation} from '@apollo/react-hooks'
import {Redirect} from 'react-router-dom'
import Heading from 'components/shared/Heading'
import Loader from 'shared/components/Loader'

import ChangeCustomProfile from './ChangeCustomProfile'
import './index.scss'

const customProfileQuery = gql`
  query CustomProfileQuery($id: ID!) {
    viewer {
      id
      photoOrderPreference {edges {node {id, name}}}
      customer {
        id
        customProfiles
      }
    }
    product(id: $id) {
      id
      ...on PhotoEditingBasedProduct {
        customProfile
      }
      ...on AssetsBasedProduct {
        assets {
          edges {
            node {
              ...on PhotoAsset {
                id
                profile
                customProfileAvailable
                image(size: "monitor") {
                  url
                  labels
                  filenameIndex
                }
              }
            }
          }
        }
      }
    }
  }
`

const setCustomProfileMutation = gql`
  mutation SetCustomProfileOnProduct($input: SetCustomProfileOnProductInput!) {
    SetCustomProfileOnProduct(input: $input) {
      product {
        ... on PhotoEditingBasedProduct {
          id
          customProfile
        }
      }
    }
  }
`

const ProductCustomProfile = ({match}) => {
  const [goBackToProduct, setGoBackToProduct] = useState(false)
  const {loading, error, data} = useQuery(customProfileQuery, {variables: {id: match.params.productId}})
  const {product, viewer} = data || {}
  const [setCustomProfile, {loading: setProfileLoading, data: setProfileData}] = useMutation(setCustomProfileMutation, {
    onCompleted: () => {
      notification['success']({
        message: 'Bildene er sendt til produksjon',
        description: 'Bildene er sendt til produksjon og vil snart bli tilgjengelig på produktsiden.',
      })
    },
    onError: () => {
      notification['error']({
        message: 'Feil!',
        description: 'Kunne ikke sende bildene til produksjon grunnet en feil. Forsøk på nytt senere.',
      })
    }
  })

  if (goBackToProduct || setProfileData) {
    window.showAsUnderProduction = product.id
    setTimeout(() => window.showAsUnderProduction = null, 5000)
    
    return (
      <Redirect to={`/oppdrag/${match.params.estateId}/produkt/${match.params.productId}`} />
    )
  }

  return (
    <div className="product-custom-profile">
      <Heading level={2}>Velg filter</Heading>

      <Loader loading={loading} error={error}>
        <ChangeCustomProfile
          setCustomProfile={setCustomProfile}
          product={product}
          viewer={viewer}
          isSubmitting={setProfileLoading}
          setGoBackToProduct={setGoBackToProduct}
        />
      </Loader>
    </div>
  )
}

export default ProductCustomProfile
